export * from './DetailList';
